export default (str, maxLength) => {
  if (!str || str.length <= maxLength) {
    return str;
  }

  return str.substr(0, maxLength) + "\u2026";
}